/* eslint-disable react/no-array-index-key */
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

const enum fields {
    number = "number",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.number]: number;
    };
}

export interface ContainerStyles {
    container?: GridContainerProps;
    tileGridItem?: GridItemProps;
}

export const containerStyles: ContainerStyles = {
    container: {        
        gap: 30,
        css: css`
            direction: ltr;
            ${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    css`
                        min-width: 400px;
                    `,
                    css`
                        min-width: 500px;
                    `,
                    css`
                        min-width: 700px;
                    `,
                    css`
                        min-width: 900px;
                    `,
                    css`
                        min-width: 1140px;
                    `,
                ]);
            }}
        `,
    },
    tileGridItem: {
        width: [12, 6, 6, 4, 4],
    },   
};

const styles = containerStyles;

type Props = OwnProps;

const ApplicationTilesContainer: React.FC<Props> = ({ id, fields }: Props) => {
    const zones: string[] = [];
    for (let index = 1; index <= fields.number; index++) {
        zones.push(`Content${index}`);
    }

    return (
        <GridContainer  {...styles.container} data-test-selector="container">
            {zones.map((zone, idx) => (
                <GridItem  key={idx} {...styles.tileGridItem}>
                    <Zone contentId={id} zoneName={zone}></Zone>
                </GridItem>                        
            ))}               
        </GridContainer>
    );
};

const widgetModule: WidgetModule = {
    component: ApplicationTilesContainer,
    definition: {
        group: "Categories",
        icon: "Carousel",
        fieldDefinitions: [
            {
                name: fields.number,
                displayName: "Number of Tiles",
                editorTemplate: "IntegerField",
                min: 1,
                defaultValue: 3,
                fieldType: "General",
                isRequired: true,
                sortOrder: 1,
            },
        ],
    },
};

export default widgetModule;
